import React from 'react';
import Box from '@mui/material/Box';

/**
 * PageShell — outermost wrapper inside every route component.
 *
 * Enforces the flex chain contract so pages don't have to remember the
 * `min-height: 0` dance. Must sit inside MainContent (which already has
 * `flex-grow: 1`), and every ancestor up to #root must also be a flex column.
 *
 * Usage:
 *   <PageShell>
 *     <PageHeader title="Invoices" />
 *     <PageContent fill>
 *       <ResponsiveDataGrid ... />
 *     </PageContent>
 *   </PageShell>
 */
export default function PageShell({ children, sx, ...rest }) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flex: '1 1 auto',
        minHeight: 0,
        height: '100%',
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Box>
  );
}
